/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';

/**
 * 
 * @export
 * @interface GetOrderEmployeeDto
 */
export interface GetOrderEmployeeDto {
    /**
     * 
     * @type {string}
     * @memberof GetOrderEmployeeDto
     */
    id: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetOrderEmployeeDto
     */
    employee: GetEmployeeDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderEmployeeDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetOrderEmployeeDto interface.
 */
export function instanceOfGetOrderEmployeeDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "employee" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetOrderEmployeeDtoFromJSON(json: any): GetOrderEmployeeDto {
    return GetOrderEmployeeDtoFromJSONTyped(json, false);
}

export function GetOrderEmployeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderEmployeeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'employee': GetEmployeeDtoFromJSON(json['employee']),
        'active': json['active'],
    };
}

export function GetOrderEmployeeDtoToJSON(value?: GetOrderEmployeeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'employee': GetEmployeeDtoToJSON(value.employee),
        'active': value.active,
    };
}

